export default __webpack_public_path__ + "assets/icons/cn_logo.32512b14.svg";